// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".deal_detail_container {\n  width: 80vw;\n  max-width: 1400px;\n  /* height: 800px; */\n  margin-left: auto;\n  margin-right: auto;\n  flex-direction: column;\n  border: 1px solid #eee;\n  padding: 10px;\n  border-radius: 5px;\n  margin-bottom: 20px;\n}\n@media screen and (max-width: 960px) {\n  .deal_detail_container {\n    width: 92vw;\n  }\n}\n", ""]);
// Exports
module.exports = exports;
